import * as z from "zod";

export const getContextualGtmContainer = {
  name: "getContextualGtmContainer" as const,
  input: z.object({ integrationId: z.string() }),
  output: z.object({ containerJson: z.string() }),
};
